import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

import Feriehjem from './assets/Feriehjem'
import Fly from './assets/Fly'
import Hotell from './assets/Hotell'
import Leiebil from './assets/Leiebil'
import Pakkereise from './assets/Pakkereise'

const Wrapper = styled.div`
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-bottom: 1px solid ${cssTheme.colors.border.neutral.primary};
`

const Tab = styled.a`
  display: grid;
  gap: ${cssTheme.layout.spacing.s300};
  text-decoration: none;
  align-items: center;
  width: fit-content;
  flex-grow: 1;
  color: ${cssTheme.colors.content.neutral.secondary};
  border-bottom: 4px solid transparent;
  padding: ${cssTheme.layout.spacing.s250} 0 0;
  text-align: center;
  &:hover,
  &:active,
  &.active {
    text-decoration: none;
    border-bottom-color: ${cssTheme.colors.border.interactive.primary};
  }
  &:hover,
  &.active {
    color: ${cssTheme.colors.content.brand.primary};
  }
  ${linariaMq.desktopXs} {
    padding: ${cssTheme.layout.spacing.s500} 0 0;
  }
`

const IconWrapper = styled.span`
  display: none;
  ${linariaMq.desktopXs} {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const HeaderTabs = () => {
  return (
    <Wrapper>
      <Tab href="https://www.finn.no/reise/" target="_self">
        <IconWrapper>
          <Fly />
        </IconWrapper>
        <Text variant="bodyS">Fly</Text>
      </Tab>
      <Tab className="active">
        <IconWrapper>
          <Hotell />
        </IconWrapper>
        <Text variant="bodyS">Hotell</Text>
      </Tab>
      <Tab href="https://www.finn.no/reise/leiebil/" target="_self">
        <IconWrapper>
          <Leiebil />
        </IconWrapper>
        <Text variant="bodyS">Leiebil</Text>
      </Tab>
      <Tab href="https://www.finn.no/reise/pakkereiser/" target="_self">
        <IconWrapper>
          <Pakkereise />
        </IconWrapper>
        <Text variant="bodyS">Pakkereise</Text>
      </Tab>
      <Tab
        href="https://www.finn.no/reise/feriehus-hytteutleie/"
        target="_self"
      >
        <IconWrapper>
          <Feriehjem />
        </IconWrapper>
        <Text variant="bodyS">Feriehjem</Text>
      </Tab>
    </Wrapper>
  )
}
